export const BASE_URL = "https://erp-go-558879015455.asia-south1.run.app/";
export const LOGIN = "api/v1/organisation/admin/login";
export const CREATE_ROLE = "api/v1/organisation/roles/create";
export const UPDATE_ROLE = "api/v1/organisation/roles/update";
export const USERS = "api/v1/organisation/users";
export const USER_ONLINE_STATUS = "api/v1/organisation/users/online-status";
export const DELETE_ROLE = "api/v1/organisation/roles/delete";
export const CREATE_USERS = "api/v1/organisation/create_user";
export const EDIT_USERS = "api/v1/organisation/edit_user/";
export const DELETE_USERS = "api/v1/organisation/delete_user";
export const ROLE = "api/v1/organisation/roles";
export const FIELD_MASTER = "api/v1/organisation/admin/field_master";
export const CREATE_TRANSACTION =
  "api/v1/organisation/admin/transaction/create";
export const GET_TRANSACTIONS = "api/v1/organisation/admin/transaction";
export const MENU = "api/v1/organisation/menu";
export const DELETE_FIELD_MASTER =
  "api/v1/organisation/admin/field_master/delete";
export const FIELD_MASTER_PROJECTIONS =
  "api/v1/organisation/admin/field_master/projections";
export const CREATE_MASTER_TRANSACTION =
  "api/v1/organisation/admin/transaction/master/create";
export const RESET_PASSWORD = "api/v1/organisation/reset_password/";
export const DEPARTMENTS = "api/v1/organisation/admin/departments";
export const CREATE_DEPARTMENT = "api/v1/organisation/admin/departments";
export const UPDATE_DEPARTMENT = "api/v1/organisation/admin/departments/update";
export const ACTIVATE_DEPARTMENT =
  "api/v1/organisation/admin/departments/activate";
export const DEACTIVATE_DEPARTMENT =
  "api/v1/organisation/admin/departments/deactivate";
export const DELETE_DEPARTMENT = "api/v1/organisation/admin/departments/delete";
